// extracted by mini-css-extract-plugin
export default {"button":"TypeSelectButton__button--3YkI_","selected":"TypeSelectButton__selected--28iYj","icon":"TypeSelectButton__icon--2Wz3b"};